'use client';
import React, { useState } from 'react';

import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import Filters from './Filters';
import { MaterialsTableContextProvider } from './MaterialsTableProvider';
import Table from './Table';
import { exportTableToPdf } from './Table/ExportTableToPdf';
import Button from '@/ui/components/Button';
import Heading from '@/ui/components/Heading';
import LayoutContainer from '@/ui/containers/layout/LayoutContainer';

const TitleWrap = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: space-between;
  margin-top: 1.25rem;
  margin-bottom: 2.5rem;

  button {
    white-space: nowrap;
  }
`;

/**
 * @todo page <title>
 * @todo css print style optimization
 * @todo no data interface
 * @todo further refactoring
 * @todo tooltips
 * @todo grayscale rows - switching filters
 */
export default function MaterialTable({ data }) {
  const [isExporting, setIsExporting] = useState(false);
  const translate = useTranslations();

  if (!data) return null;

  const handleExportPdf = async () => {
    setIsExporting(true);
    try {
      const title = translate('page-title-materialsGuide');
      await exportTableToPdf(title);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <MaterialsTableContextProvider materialsTableData={data}>
      <LayoutContainer sx={{ paddingBottom: '0' }}>
        <TitleWrap
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Heading
            headingSize="h1"
            headingComponent="h1"
            sx={{
              marginTop: 0,
              marginBottom: 0,
            }}
          >
            {translate('materialGuide-title')}
          </Heading>

          {data.length > 0 && (
            <div>
              <Button
                onClick={handleExportPdf}
                disabled={isExporting}
                loading={isExporting}
                icon="file-pdf"
                variant="contained"
                color="primary"
              >
                {translate('materialGuide-export-to-pdf')}
              </Button>
            </div>
          )}
        </TitleWrap>
      </LayoutContainer>

      <LayoutContainer sx={{ paddingBottom: '0' }}>
        <Filters />
      </LayoutContainer>
      <Table exporting={isExporting} />
    </MaterialsTableContextProvider>
  );
}
